import React from 'react'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import { navigate } from 'gatsby'
import Cart from 'gatsby-theme-marketplace-base/src/components/Navigation/Cart'
import userSession from 'gatsby-theme-marketplace-base/src/utils/auth/userSession'
import { isAuthorized } from 'gatsby-theme-marketplace-base/src/store/selectors'

const CartWrapper = ({ isUserAuthorized, ...rest }) => {
  const signInAndNavigate = async () => {
    await userSession.signIn()
    navigate('/cart/')
  }

  const handleClick = () => {
    if (isUserAuthorized) {
      navigate('/cart/')
    } else {
      signInAndNavigate()
    }
  }

  return <Cart {...rest} handleClick={handleClick} />
}

CartWrapper.propTypes = {
  isUserAuthorized: bool,
}

const mapStateToProps = (state) => {
  return {
    isUserAuthorized: isAuthorized(state),
  }
}

const CartWrapperWithRedux = connect(
  mapStateToProps,
  null
)(CartWrapper)
export default (props) => <CartWrapperWithRedux {...props} />
